import { render, staticRenderFns } from "./MobileContainerTrackingSearchResultItemVoyage.vue?vue&type=template&id=02136460&scoped=true&"
import script from "./MobileContainerTrackingSearchResultItemVoyage.vue?vue&type=script&lang=js&"
export * from "./MobileContainerTrackingSearchResultItemVoyage.vue?vue&type=script&lang=js&"
import style0 from "./MobileContainerTrackingSearchResultItemVoyage.vue?vue&type=style&index=0&id=02136460&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02136460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02136460')) {
      api.createRecord('02136460', component.options)
    } else {
      api.reload('02136460', component.options)
    }
    module.hot.accept("./MobileContainerTrackingSearchResultItemVoyage.vue?vue&type=template&id=02136460&scoped=true&", function () {
      api.rerender('02136460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/vsl/ContainerTrackingSearch/MobileContainerTrackingSearchResultItemVoyage.vue"
export default component.exports